const ClassStringBuilder = (classes: (string | false)[]) => classes.filter(Boolean).join(' ');

export default ClassStringBuilder;
